import React from 'react'
import Philadelphia from '../components/Philadelphia.jsx'

const PhiladelphiaPage = () => {

return(
    <Philadelphia/>
)
}

export default PhiladelphiaPage